import { render, staticRenderFns } from "./CrmTaskReminder.vue?vue&type=template&id=7b82ebc6&scoped=true"
import script from "./CrmTaskReminder.vue?vue&type=script&lang=js"
export * from "./CrmTaskReminder.vue?vue&type=script&lang=js"
import style0 from "./CrmTaskReminder.vue?vue&type=style&index=0&id=7b82ebc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b82ebc6",
  null
  
)

export default component.exports